module.exports = __webpack_public_path__ + "img/gbk.897b4fc9.png";